import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Divider } from "@mui/material";
import { toast } from "react-toastify";
import { EditOutlined } from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import EnableDisableButton from "components/Shared/EnableDisableButton";
import { VehicleDetailContext, useVehicleDetailContext } from "contexts/VehicleDetailContext";
import { useAppMeta, useAuth } from "hooks";
import VehicleDetailTab from "./vehicleComponents/VehicleDetailTab";
import VehicleBasicDetail from "./vehicleComponents/VehicleBasicDetail";
import { useGetVehicleDetailQuery, useUpdateVehicleMutation } from "store/services/vehicleApi";

const VehicleDetailScreen = () => {

  const { id } = useParams();

  const { data: vehicleDetail, isLoading: loadingVehicle, error } = useGetVehicleDetailQuery(id);

  const breadcrumbs = [
    { title: "Vehicles", path: "/app/crm/vehicle/list" },
    { title: "Vehicle Detail" },
  ];

  useAppMeta("Vehicle Detail");

  return (
    <VehicleDetailContext.Provider value={{ vehicleDetail, loadingVehicle }}>
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingVehicle}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />
        <BreadcrumbLayout.Paper>
          <VehicleBasicDetail />
          <Divider />
          <VehicleDetailTab />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </VehicleDetailContext.Provider>
  );
};

export default VehicleDetailScreen;

const PageActions = () => {
  
  const { isAccountAdmin } = useAuth();
  
  const { vehicleDetail, loadingVehicle } = useVehicleDetailContext();

  const [updateVehicle, { isLoading: updatingVehicle }] = useUpdateVehicleMutation();

  const handleToggleVehicleStatus = async () => {
    if (!vehicleDetail?._id) return;
    try {
      const updatedStatus = !vehicleDetail?.status;
      await updateVehicle({
        _id: vehicleDetail?._id,
        status: updatedStatus,
      }).unwrap();
      toast.info(`Vehicle successfully ${updatedStatus ? "Activated" : "Deactivated"}!`);
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update Vehicle Status!");
    }
  };

  return (
    <div className="flex items-center gap-4">
      {isAccountAdmin &&(<EnableDisableButton
        status={vehicleDetail?.status ?? false}
        loading={loadingVehicle || updatingVehicle}
        disabled={!vehicleDetail}
        onClick={handleToggleVehicleStatus}
      />)}
      <Link to={`/app/crm/vehicle/${vehicleDetail?._id}/edit`}>
        <Button
          startIcon={<EditOutlined />}
          variant="contained"
          disabled={!vehicleDetail}
        >
          Edit
        </Button>
      </Link>
    </div>
  );
};